$traceurRuntime.ModuleStore.getAnonymousModule(function() {
  "use strict";
  angular.module('app.player').controller('StartCtrl', (function($scope, $state, Backend, AudioManager) {
    $scope.baseurl = (typeof localized !== 'undefined' ? localized.assets : '');
    $scope.$on('$viewContentLoaded', (function() {
      $scope.code = '';
    }));
    $scope.start = (function() {
      $state.go('main-dispatch', {quiz: $scope.code});
    });
  })).controller('AnswerCtrl', (function($scope, $state, Backend, AudioManager) {
    $(document).on('click', '.option', function(e) {
      e.preventDefault();
      if ($(this).hasClass('is-selected')) {
        $(this).removeClass('is-selected');
      } else {
        $(this).addClass('is-selected');
      }
    });
  })).factory('dispatchOnScreenType', (function($state, $stateParams) {
    function ensureScreen(screen, force) {
      var supposedState = 'main-' + screen.type;
      if ($state.current.name != supposedState || force) {
        console.log('dispatching to ' + supposedState);
        $state.go(supposedState, $stateParams, {reload: force});
      }
    }
    return function(scope, channel) {
      channel.on(scope, 'game_status', (function(state) {
        scope.screen = state.screen;
        scope.state = state;
        ensureScreen(state.screen);
      }));
      channel.on(scope, 'show_screen', (function(screen) {
        ensureScreen(screen, true);
      }));
      channel.on(scope, 'phx_reply', (function(screen) {}));
      return true;
    };
  })).controller('DispatchCtrl', (function($scope, $state, playerChannel, dispatchOnScreenType) {
    dispatchOnScreenType($scope, playerChannel);
  })).controller('QuestionCtrl', (function($scope, $state, $stateParams, playerChannel, gameConfig, dispatchOnScreenType, TestScore, AudioManager) {
    dispatchOnScreenType($scope, playerChannel);
    AudioManager.load();
    $scope.quizid = $stateParams.quiz;
    $scope.stop = (function() {
      $state.go('start', {}, {reload: true});
    });
    $scope.chosenAnswer = false;
    $scope.game_config = gameConfig;
    $scope.chooseAnswer = (function(idx) {
      AudioManager.play('click');
      if (idx === $scope.chosenAnswer) {
        idx = false;
      }
      $scope.chosenAnswer = idx;
      playerChannel.push('answer', {answer: idx});
      var isScoreTest = (typeof $scope.screen.feedback.scores !== 'undefined' ? $scope.screen.feedback.scores : false);
      if (isScoreTest) {
        var answer_score = 0;
        answer_score = isScoreTest[idx];
        TestScore.add($scope.screen.id, answer_score);
        console.log(TestScore.score());
      }
    });
  })).controller('MultipleCtrl', (function($scope, $state, $stateParams, playerChannel, gameConfig, dispatchOnScreenType) {
    dispatchOnScreenType($scope, playerChannel);
    $scope.quizid = $stateParams.quiz;
    $scope.stop = (function() {
      $state.go('start', {}, {reload: true});
    });
    $scope.game_config = gameConfig;
    $scope.answered = {};
    $scope.answer_active = {};
    $scope.toggleAnswer = (function(idx) {
      $scope.answer_active[idx] = true;
      $scope.answered[idx] = !$scope.answered[idx];
      playerChannel.push('answer', {answer: idx});
    });
    $scope.selectAnswer = (function(idx, state) {
      $scope.answered[idx] = state;
      playerChannel.push('answer', {answer: idx});
      if (state === false && !$scope.answer_active[idx]) {
        playerChannel.push('answer', {answer: idx});
      }
      $scope.answer_active[idx] = true;
    });
  })).controller('MessageCtrl', (function($scope, $state, $stateParams, playerChannel, dispatchOnScreenType, TestScore, BaseUrl) {
    dispatchOnScreenType($scope, playerChannel);
    $scope.baseurl = BaseUrl;
    $scope.quizid = $stateParams.quiz;
    $scope.stop = (function() {
      $state.go('start', {}, {reload: true});
    });
    setTimeout(function() {
      getFeedback();
    }, 10);
    function getFeedback() {
      if ($scope.screen.subtype == 'results') {
        var testScore = TestScore.score();
        $scope.screen.feedback.forEach(function(score) {
          if ((testScore >= score.min) && (testScore <= score.max)) {
            $scope.resultFeedbackTitle = score.title;
            $scope.resultFeedbackExplanation = score.explanation;
          }
        });
      }
    }
  }));
  ;
  return {};
});

